import { render, staticRenderFns } from "./HistoryRecordChanges.vue?vue&type=template&id=de078732&scoped=true&"
import script from "./HistoryRecordChanges.vue?vue&type=script&lang=js&"
export * from "./HistoryRecordChanges.vue?vue&type=script&lang=js&"
import style0 from "./HistoryRecordChanges.vue?vue&type=style&index=0&id=de078732&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de078732",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de078732')) {
      api.createRecord('de078732', component.options)
    } else {
      api.reload('de078732', component.options)
    }
    module.hot.accept("./HistoryRecordChanges.vue?vue&type=template&id=de078732&scoped=true&", function () {
      api.rerender('de078732', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/RecordHistory/HistoryRecordChanges.vue"
export default component.exports